<form [formGroup]="formData">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Received Date</label>
          <input type="date" class="form-control" formControlName="reported_date" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Reported By</label>
          <input type="text" class="form-control" formControlName="reported_by" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Defect Type</label>
          <select formControlName="defect_type" class="form-control">
            <option *ngFor="let dt of drSvc.defectTypes" [value]="dt.id">
              {{ dt.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-6 flex align-items-center">
        <div class="form-group m-0 w-100">
          <mat-checkbox
            class="px-3 py-2"
            color="primary"
            formControlName="isAffectingInventory"
          >
            Affects Inventory
          </mat-checkbox>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        SKUs/Products
        <button class="btn btn-info" (click)="addPOItems()">
          Add SKU/Product
        </button>
      </legend>
      <table class="table">
        <thead>
          <tr>
            <th>Received Date</th>
            <th>SKU</th>
            <th>Product Name</th>
            <th>PO # / Factory</th>
            <th>Warehouse</th>
            <ng-container *ngIf="ftLocationBins">
              <th>Location</th>
            </ng-container>
            <ng-container *ngIf="ftLocationBins && ftLotTracking">
              <th>Lot Number</th>
            </ng-container>
            <th>Defective Qty</th>
            <th>Unit</th>
            <th>Remarks</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody formArrayName="items">
          <tr
            *ngFor="
              let item of formData['controls'].items['controls'];
              let idx = index
            "
            [formGroupName]="idx"
          >
            <td>
              {{ item.value.received_date | date: 'mediumDate' }}
            </td>
            <td>{{ item.value.sku || 'N/A' }}</td>
            <td>{{ item.value.product_name }}</td>
            <td>
              {{ item.value.purchase_order_id | purchaseOrderFormat }} <br />
              <b>{{ item.value.factory_name }}</b>
            </td>
            <td>
              {{ getLocation(item.value.warehouse_id) }}
            </td>
            <td *ngIf="ftLocationBins">
              {{ getLocationWithoutParent(item.value.location_id) }}
            </td>
            <td *ngIf="ftLocationBins && ftLotTracking">
              <span *ngIf="enabledBinLocationAndLotTracking(item)">
                {{ getRfqLotNumber(item.value.rfq_id, item.value.lot_id) }}
              </span>
            </td>
            <td>
              <input
                type="number"
                class="form-control text-right m100"
                name="{{ 'qty' + idx }}"
                formControlName="quantity"
                (change)="computeLineTotal(idx)"
                lumDecimalLimit
              />
            </td>

            <td>
              <ng-select
                [items]="unitOfMeasures[item?.value?.rfq_id]"
                bindValue="id"
                bindLabel="name"
                formControlName="defective_uom_id"
                [multiple]="false"
                [clearable]="false"
                class="uom"
                (change)="computeLineTotal(idx)"
              >
              </ng-select>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                name="{{ 'remarks' + idx }}"
                formControlName="remarks"
              />
            </td>
            <td>
              <a
                href="javascript:;"
                (click)="formData.get('items').removeAt(idx); computeTotal()"
              >
                <i class="fas fa-times text-danger"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group text-right">
            <label for="">Total Units</label>
            <h3>{{ totalUnits | decimalPlaces }}</h3>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group text-right">
            <label for="">Total Cost</label>
            <h3>{{ totalCost | currency: '' }}</h3>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [disabled]="loading"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="button"
      class="btn btn-success"
      [disabled]="loading"
      (click)="save()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      <i class="fas fa-check"></i> Save Defective Report
    </button>
  </div>
</form>
